<template>
  <v-progress-circular
    v-if="isLoading"
    :size="70"
    :width="7"
    color="primary"
    indeterminate
    class="centered"
  ></v-progress-circular>
  <div v-else>
    <h1 class="text-center mt-3">Broadcast Message</h1>
    <div class="form shadow p-5 mb-5 bg-white rounded">
      <div class="row">
        <div class="col">
          <BrandDropdown
            :setDisable="!!this.id"
            v-model="form.brandSelected"
            @setBrand="setBrand"
            @setBrands="setBrands"
            :class="{
              'input--error': isSubmit && error.errorBrand,
            }"
            required="true"
          ></BrandDropdown>
          <div v-if="isSubmit && error.errorBrand" class="text-error">
            {{ error.errorBrand.message }}
          </div>
        </div>
        <div class="col"></div>
      </div>
      <div class="row">
        <div class="col">
          <label for="campaignName"
            >Campaign Name<span class="required">*</span></label
          >
          <input
            id="campaignName"
            :disabled="!!this.id"
            type="text"
            v-model="form.name"
            class="form-control"
            :class="{
              'input--error': isSubmit && error.errorName,
            }"
          />
          <div v-if="isSubmit && error.errorName" class="text-error">
            {{ error.errorName.message }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <label for="sendTime">Send time<span class="required">*</span></label>
          <VueCtkDateTimePicker
            id="sendTime"
            :disabled="!!this.id"
            v-model="form.sendTime"
            format="DD/MM/YYYY HH:mm"
            formatted="DD MMM YYYY HH:mm"
            :noHeader="true"
            :noLabel="true"
            :class="{
              'input--error': isSubmit && error.errorSendTime,
            }"
          />
          <div v-if="isSubmit && error.errorSendTime" class="text-error">
            {{ error.errorSendTime.message }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div>Customer data<span class="required">*</span></div>
          <div class="d-flex flex-row">
            <div class="form-check form-check-inline pr-5">
              <input
                :disabled="!!this.id"
                class="form-check-input"
                type="radio"
                name="customerDataType"
                id="CUSTOMER_CODE"
                value="CUSTOMER_CODE"
                v-model="form.customerDataType"
                :class="{
                  'input--error': isSubmit && error.errorCustomerDataType,
                }"
              />
              <label class="form-check-label" for="CUSTOMER_CODE"
                >Member ID</label
              >
            </div>
            <div class="form-check form-check-inline">
              <input
                :disabled="
                  !!this.id || form.type === 'LINE' || form.type === 'PUSH_NOTI'
                "
                class="form-check-input"
                type="radio"
                name="customerDataType"
                id="MOBILE"
                value="MOBILE"
                v-model="form.customerDataType"
                :class="{
                  'input--error': isSubmit && error.errorCustomerDataType,
                }"
              />
              <label class="form-check-label" for="MOBILE">Mobile</label>
            </div>
            <div
              v-if="isSubmit && error.errorCustomerDataType"
              class="text-error"
            >
              {{ error.errorCustomerDataType.message }}
            </div>
          </div>
        </div>
        <div class="col"></div>
      </div>
      <div class="row">
        <div class="col">
          <div class="d-flex align-items-center justify-content-start">
            <label for="broadcastMessageImportFile"
              >Import data from file<span class="required">*</span></label
            >
            &nbsp;
            <a href="#" target="_blank" @click.prevent="downloadSampleFile"
              >Download sample file</a
            >
          </div>
          <small class="file-remark" v-if="!this.id"
            >Caution: The file can contain up to 100,000 data records. If it
            contains more than that, only the first 100,000 records will be
            imported to the system and the rest records will be ignored.</small
          >
          <a
            style="display: none"
            :href="form.downloadLink"
            ref="downloadLink"
            aria-label="Download file"
          />
          <a v-if="this.id" @click="$refs.downloadLink.click()" class="trigger"
            >Download</a
          >
          <div v-else>
            <input
              id="broadcastMessageImportFile"
              type="file"
              @change="uploadImportFile"
              ref="importBroadcastMessageFile"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              class="form-control"
              :class="{
                'input--error': isSubmit && error.errorFileKey,
              }"
              :disabled="isFileLoading"
            />
            <div v-if="selectedFile && !isFileLoading" class="pt-2">
              {{ selectedFile }}
            </div>
            <div v-if="isSubmit && error.errorFileKey" class="text-error">
              {{ error.errorFileKey.message }}
            </div>
          </div>
        </div>
        <div class="col d-flex align-items-end pb-5">
          <FileLoading v-if="isFileLoading" />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div>Send via<span class="required">*</span></div>
          <div class="d-flex flex-row">
            <div class="form-check form-check-inline pr-5">
              <input
                :disabled="!!this.id"
                class="form-check-input"
                type="radio"
                name="type"
                id="SMS"
                value="SMS"
                v-model="form.type"
                :class="{
                  'input--error': isSubmit && error.errorType,
                }"
                @change="selectType"
              />
              <label class="form-check-label" for="SMS">SMS</label>
            </div>
            <div class="form-check form-check-inline pr-5">
              <input
                :disabled="!!this.id || form.customerDataType === 'MOBILE'"
                class="form-check-input"
                type="radio"
                name="type"
                id="LINE"
                value="LINE"
                v-model="form.type"
                :class="{
                  'input--error': isSubmit && error.errorType,
                }"
                @change="selectType"
              />
              <label class="form-check-label" for="LINE">Line message</label>
            </div>
            <div class="form-check form-check-inline">
              <input
                :disabled="!!this.id || form.customerDataType === 'MOBILE'"
                class="form-check-input"
                type="radio"
                name="type"
                id="PUSH_NOTI"
                value="PUSH_NOTI"
                v-model="form.type"
                :class="{
                  'input--error': isSubmit && error.errorType,
                }"
                @change="selectType"
              />
              <label class="form-check-label" for="PUSH_NOTI"
                >Push notification</label
              >
            </div>
            <div v-if="isSubmit && error.errorType" class="text-error">
              {{ error.errorType.message }}
            </div>
          </div>
        </div>
      </div>
      <LineMessageTemplate
        v-show="form.type === 'LINE'"
        v-bind="templateProps"
        identifier="singleTemplate"
        :error-message-templates="error.errorMessageTemplateLine"
      />
      <SmsMessageTemplate
        v-show="form.type === 'SMS'"
        v-bind="templateProps"
        identifier="singleTemplate"
        :error-message-templates="error.errorMessageTemplateSms"
      />
      <PushNotificationTemplate
        v-show="form.type === 'PUSH_NOTI'"
        v-bind="templateProps"
        identifier="singleTemplate"
        :error="error"
        :error-message-templates="error.errorMessageTemplatePushNoti"
      />
      <div v-if="isSubmit && error.errorMessageTemplate" class="text-error">
        {{ error.errorMessageTemplate.message }}
      </div>
      <div class="row" v-if="this.id">
        <div class="col">
          <label for="noOfCustomers">The number of customers</label>
          <NumberInput input-id="noOfCustomers" v-model.number="form.noOfImportedCustomer" :disabled="true"/>
        </div>
        <div class="col"></div>
      </div>
      <div class="row" v-if="this.id">
        <div class="col">
          <label for="estimatedReach">Estimated reach</label>
          <NumberInput input-id="estimatedReach" v-model.number="form.estimatedReach" :disabled="true"/>
        </div>
        <div class="col">
          <label for="successfullySent">Successfully sent</label>
          <NumberInput input-id="successfullySent" v-model.number="form.successfullySent" :disabled="true"/>
        </div>
      </div>
      <div class="row" v-if="this.id">
        <div class="col">
          <div class="d-flex align-items-center justify-content-start">
            <div><strong>Status: </strong> &nbsp; {{ form.status }}</div>
            <button
              v-if="this.id && this.form.status === 'ACTIVE'"
              class="btn btn-outline-danger ml-5"
              style="margin: 0"
              @click="showCancelDialog"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
      <div class="row" v-if="this.id">
        <div class="col">
          <div class="d-flex align-items-center justify-content-start">
            <div>
              <strong>Date created: </strong> &nbsp; {{ form.dateCreated }}
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="this.id">
        <div class="col">
          <div class="d-flex align-items-center justify-content-start">
            <div>
              <strong>Last updated: </strong> &nbsp; {{ form.lastUpdated }}
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="this.id">
        <div class="col">
          <div class="d-flex align-items-center justify-content-start">
            <div><strong>Created by: </strong> &nbsp; {{ form.createdBy }}</div>
          </div>
        </div>
      </div>
      <div class="row pa-3" v-if="this.isImportError">
        <v-alert
            prominent
            dense
            type="error"
        >
          {{ errorMessage }}
        </v-alert>
      </div>
      <div class="d-flex justify-content-end mt-5">
        <router-link
          :to="{ name: 'BroadcastMessages' }"
          class="btn btn-outline-secondary btn-back-to-list"
          >Back</router-link
        >
        <button
          v-if="!this.id"
          class="btn btn-outline-success ml-10"
          @click="checkValidate"
        >
          Save
        </button>
      </div>
    </div>

    <v-dialog v-model="showDialog" width="500" persistent>
      <div class="content-dialog">
        <h3 v-if="showSuccess">{{ message }}</h3>
        <h5 class="p-5 failureMessage" v-else>{{ message }}</h5>
        <div class="text-center">
          <button
            v-if="showSuccess"
            class="btn-back"
            @click="() => $router.push({ name: 'BroadcastMessages' })"
          >
            กลับสู่หน้าหลัก
          </button>
          <button v-else class="btn-back" @click="showDialog = false">
            ปิด
          </button>
        </div>
      </div>
    </v-dialog>

    <v-dialog v-model="isShowCancelDialog" width="500" persistent>
      <div class="content-dialog">
        <h3>Are you sure to cancel this broadcast message?</h3>
        <div class="text-center">
          <button class="btn-back mr-5" @click="cancel()">ใช่</button>
          <button class="btn-back" @click="hideCancelDialog()">ปิด</button>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment/moment";
import BroadcastMessagesService from "services/api/broadcastMessages.service";
import BrandDropdown from "components/Brand/BrandDropdown";
import SmsMessageTemplate from "components/MessageTemplate/SmsMessageTemplate.vue";
import LineMessageTemplate from "components/MessageTemplate/LineMessageTemplate.vue";
import PushNotificationTemplate from "components/MessageTemplate/PushNotificationTemplate.vue";
import DefaultMessageTemplateData from "components/MessageTemplate/defaultMessageTemplateData";
import FileLoading from "components/Loading/FileLoading.vue";
import NumberInput from "components/NumberInput/NumberInput.vue";
import PresignedUploadUrlService from "services/api/presignedUploadUrl.service";
import ErrorFields from "./errorFields";
import { BroadcastMessageFieldLevelError } from "./broadcastMessageFieldLevelError";

export default {
  components: {
    NumberInput,
    FileLoading,
    BrandDropdown,
    SmsMessageTemplate,
    LineMessageTemplate,
    PushNotificationTemplate,
  },

  data() {
    return {
      id: this.$route.query.id,
      processId: null,
      getResultInterval: null,
      message: "",
      showSuccess: false,
      showDialog: false,
      isShowCancelDialog: false,
      isLoading: false,
      isFileLoading: false,
      isSubmit: false,
      isComplete: true,
      nullParam: "{{}}",
      firstNameParam: "{{first name}}",
      selectedFile: null,
      form: {
        id: null,
        brandSelected: null,
        name: null,
        sendTime: null,
        customerDataType: null,
        fileKey: null,
        downloadLink: null,
        type: null,
        messageTemplates: {
          ...DefaultMessageTemplateData,
          showUntil: null,
        },
        noOfImportedCustomer: null,
        estimatedReach: null,
        successfullySent: null,
        status: null,
        dateCreated: null,
        lastUpdated: null,
        createdBy: null,
      },
      error: {
        ...ErrorFields,
      },
      errorMessage: "",
      isImportError: false,
    };
  },

  mounted() {
    if (this.id) {
      this.getBroadcastMessageDetail();
    }
  },

  computed: {
    templateProps() {
      return {
        "trigger-type": this.form.triggerType,
        "message-template": this.form.messageTemplates,
        error: this.error,
        "is-submit": this.isSubmit,
        "is-broadcast": true,
        "is-remark-shown": !this.id,
        "is-disabled": !!this.id,
      };
    },
  },
  methods: {
    checkValidate() {
      this.isSubmit = true;
      this.isLoading = true;

      const form = this.form;
      this.showSuccess = false;
      const formData = new FormData();

      formData.append(
        "brandCode",
        form.brandSelected ? form.brandSelected.id : null
      );
      formData.append("name", form.name);
      formData.append("sendTime", form.sendTime || null);
      formData.append("customerDataType", form.customerDataType);
      formData.append("fileKey", form.fileKey);
      formData.append("type", form.type);
      if (form.type === "SMS") {
        formData.append(
          "messageTemplateSms",
          form.messageTemplates.messageTemplateSms
        );
      } else if (form.type === "LINE") {
        formData.append(
          "messageTemplateLine",
          form.messageTemplates.messageTemplateLine
        );
        formData.append(
          "imageRelativePath",
          form.messageTemplates.imageRelativePath
        );
        formData.append("targetUrl", form.messageTemplates.targetUrl);
        formData.append(
          "previewImageRelativePath",
          form.messageTemplates.previewImageRelativePath
        );
        formData.append(
          "videoRelativePath",
          form.messageTemplates.videoRelativePath
        );
      } else if (form.type === "PUSH_NOTI") {
        formData.append("messageTitle", form.messageTemplates.messageTitle);
        formData.append(
          "messageTemplatePushNoti",
          form.messageTemplates.messageTemplatePushNoti
        );
        formData.append(
          "pushNotiTargetUrl",
          form.messageTemplates.pushNotiTargetUrl
        );
        formData.append(
          "showInInbox",
          String(form.messageTemplates.showInInbox)
        );
        formData.append("showUntil", form.messageTemplates.showUntil);
      }
      this.createBroadcastMessage(formData);
    },
    cancel() {
      this.isSubmit = true;
      this.isLoading = true;
      this.cancelBroadcastMessage(this.id);
    },
    async createBroadcastMessage(body) {
      await BroadcastMessagesService.createBroadcastMessage(body)
        .then((res) => {
          const data = res.data;
          if (data.status === "failure") {
            this.isLoading = false;
            this.setErrorText(data.errors);
          } else {
            this.resetErrorText();
            this.checkBroadcastResponseStatus(data);
          }
        })
        .catch((err) => {
          this.isLoading = false;
          const errorMessage = err.response?.data?.message;
          if (errorMessage) {
            this.showDialog = true;
            this.message = errorMessage;
          }
          console.log("Error: ", err.response);
        });
    },
    async getCreateResult() {
      const param = {
        process: this.processId,
      };
      await BroadcastMessagesService.getBroadcastMessageResult(param)
        .then((res) => {
          const data = res.data;
          if (data) {
            this.isComplete = true;
          }
          if (
            data.processStatus === "SUCCEEDED" ||
            data.processStatus === "FAILED"
          ) {
            this.clearTimeInterval();
            this.isLoading = false;
            if (data.message) {
              this.showDialog = true;
              this.message = data.message;
            }
            if (data.status === "success") {
              this.showSuccess = true;
              this.error.errorBrand = null;
              this.resetErrorText();
            } else {
              this.setErrorText(data.errors);
            }
          }
        })
        .catch((err) => {
          this.checkErrorStatusStartWithFour(err);
        });
    },
    async getBroadcastMessageDetail() {
      this.isLoading = true;
      await BroadcastMessagesService.getDetailBroadcastMessage(this.id)
        .then((res) => {
          const data = res.data.broadcastMessage;
          this.isLoading = false;
          const form = this.form;
          form.name = data.name;
          form.type = data.type;
          form.sendTime = moment(data.sendTime).format("DD-MM-YYYY HH:mm");
          form.customerDataType = data.customerDataType;
          form.messageTemplates.messageTemplateSms = data.messageTemplateSms;
          form.messageTemplates.messageTemplateLine = data.messageTemplateLine;
          form.messageTemplates.imageRelativePath = data.imageRelativePath;
          form.messageTemplates.imageRelativePathUrl =
            data.imageRelativePathUrl;
          form.messageTemplates.targetUrl = data.targetUrl;
          form.messageTemplates.previewImageRelativePath =
            data.previewImageRelativePath;
          form.messageTemplates.previewImageRelativePathUrl =
            data.previewImageRelativePathUrl;
          form.messageTemplates.videoRelativePath = data.videoRelativePath;
          form.messageTemplates.videoRelativePathUrl =
            data.videoRelativePathUrl;
          form.messageTemplates.messageTitle = data.messageTitle;
          form.messageTemplates.messageTemplatePushNoti =
            data.messageTemplatePushNoti;
          form.messageTemplates.pushNotiTargetUrl = data.pushNotiTargetUrl;
          form.messageTemplates.showInInbox = data.showInInbox;
          form.messageTemplates.showUntil = moment(data.showUntil).format(
            "DD-MM-YYYY HH:mm"
          );
          form.downloadLink = data.downloadLink;
          form.noOfImportedCustomer = data.noOfImportedCustomer;
          form.estimatedReach = data.estimatedReach;
          form.successfullySent = data.successfullySent;
          form.status = data.status;
          form.createdBy = data.createdBy;
          form.dateCreated = moment(data.dateCreated).format(
            "DD-MM-YYYY HH:mm:ss"
          );
          form.lastUpdated = moment(data.lastUpdated).format(
            "DD-MM-YYYY HH:mm:ss"
          );
          if(data.importResultStatus === "Failure") {
            this.isImportError = true;
            this.errorMessage = data.importResultMessage ?? "Import Failed";
          }
          this.setBrand(data.brandCode);
        })
        .catch((err) => {
          this.isLoading = false;
          console.log("Error: ", err.response);
          const errorResponse = err.response;
          const isStatusStartWithFive = errorResponse.status
            ? String(errorResponse.status).startsWith("5")
            : false;

          if (isStatusStartWithFive) {
            this.showDialog = true;
            this.message =
              "The server encountered an internal error, Please try again later!";
          }
        });
    },
    async cancelBroadcastMessage(id) {
      await BroadcastMessagesService.cancelBroadcastMessage(id)
        .then((res) => {
          const data = res.data;
          this.checkBroadcastResponseStatus(data);
        })
        .catch((err) => {
          this.isLoading = false;
          console.log("Error: ", err.response);
        });
    },
    async getCancelResult() {
      const param = {
        process: this.processId,
      };
      await BroadcastMessagesService.getBroadcastMessageCancelResult(param)
        .then((res) => {
          const data = res.data;
          if (data) {
            this.isComplete = true;
          }
          if (data.processStatus.toUpperCase() === "EXECUTED") {
            this.clearTimeInterval();
            this.isLoading = false;
            this.showDialog = true;
            this.isShowCancelDialog = false;
            this.message = data.message;
            if (data.status === "success") {
              this.showSuccess = true;
            }
          }
        })
        .catch((err) => {
          this.checkErrorStatusStartWithFour(err);
        });
    },
    checkBroadcastResponseStatus(data) {
      if (data.status === "success") {
        this.processId = data.processId;
        this.getResultInterval = setInterval(() => {
          if (this.isComplete === true) {
            if (this.id) {
              this.getCancelResult();
            } else {
              this.getCreateResult();
            }
            this.isComplete = false;
          }
        }, 10000);
      } else {
        this.showDialog = true;
        this.message = data.message;
      }
    },
    checkErrorStatusStartWithFour(err) {
      this.isComplete = true;
      const errorResponse = err.response;
      const isStatusStartWithFour = errorResponse.status
        ? String(errorResponse.status).startsWith("4")
        : false;

      if (isStatusStartWithFour) {
        this.isComplete = false;
        this.isLoading = false;
        console.log("Error: ", errorResponse);
      }
    },
    showCancelDialog() {
      this.isShowCancelDialog = true;
    },
    hideCancelDialog() {
      this.isShowCancelDialog = false;
    },
    clearTimeInterval() {
      clearInterval(this.getResultInterval);
    },
    setErrorText(errorsFromApi) {
      BroadcastMessageFieldLevelError(this.error, errorsFromApi);
    },
    resetErrorText() {
      this.error = {
        ...ErrorFields,
      };
    },
    uploadImportFile() {
      const file = this.$refs.importBroadcastMessageFile.files[0];
      this.selectedFile = file.name;
      this.getPresignURL(file);
    },
    async getPresignURL(file) {
      this.isFileLoading = true;
      await PresignedUploadUrlService.getS3SignUrl("broadcastMessages", file)
        .then((res) => {
          const data = res.data;
          this.form.fileKey = data.key;
          this.updatePhotoToS3(data.presignedUrl, file);
        })
        .catch((err) => {
          console.log("Error: ", err.response);
        });
    },
    async updatePhotoToS3(url, file) {
      await PresignedUploadUrlService.pushProfilePhotoToS3(url, file);
      this.isFileLoading = false;
      this.$refs.importBroadcastMessageFile.value = null;
    },
    downloadSampleFile() {
      try {
        if (this.form.customerDataType === "MOBILE") {
          window.open(
            process.env.VUE_APP_HOST_API +
              "static/sample/sampleBroadcastMessageImportWithMobile.xlsx"
          );
        } else {
          window.open(
            process.env.VUE_APP_HOST_API +
              "static/sample/sampleBroadcastMessageImportWithMemberID.xlsx"
          );
        }
      } catch (error) {
        console.log("Error: ", error);
      }
    },
    selectType() {
      const typeFieldMapping = {
        LINE: [
          "messageTemplateSms",
          "messageTemplatePushNoti",
          "pushNotiTargetUrl",
          "showInInbox",
          "showUntil",
        ],
        SMS: [
          "messageTemplateLine",
          "imageRelativePath",
          "targetUrl",
          "previewImageRelativePath",
          "videoRelativePath",
          "messageTemplatePushNoti",
          "pushNotiTargetUrl",
          "showInInbox",
          "showUntil",
        ],
        PUSH_NOTI: [
          "messageTemplateSms",
          "messageTemplateLine",
          "imageRelativePath",
          "targetUrl",
          "previewImageRelativePath",
          "videoRelativePath",
        ],
      };

      if (typeFieldMapping[this.form.type]) {
        this.resetFields(typeFieldMapping[this.form.type]);
      }
    },
    resetFields(fieldNames) {
      fieldNames.forEach((fieldName) => {
        if (fieldName === "showInInbox") {
          this.form.messageTemplates[fieldName] = false;
        } else {
          this.form.messageTemplates[fieldName] = null;
        }
      });
    },
    setBrand(brand) {
      this.form.brandSelected = brand || "";
    },
    setBrands(brands) {
      brands.forEach((brand) => {
        if (brand.id === this.form.brandSelected) {
          this.form.brandSelected = brand;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.btn {
  margin: 3rem 0;
}

.btn-back-to-list {
  color: #333;
  .btn-back-to-list:hover {
    color: white;
  }
}

.text-error {
  color: red;
  font-size: 12px;
}

.content-dialog {
  height: 300px;
  background: #fff;
  h3 {
    text-align: center;
    padding: 5rem 0 2rem;
  }
  .btn-back {
    border: 1px solid #1976d2;
    width: 28%;
    height: 39px;
    border-radius: 25px;
    color: #1976d2;
  }
  .btn-back:hover {
    text-decoration: underline;
  }
}

.failureMessage {
  text-align: center;
}

.file-remark {
  color: #ff0000;
}
</style>
